module.exports = __webpack_public_path__ + "static/media/MainPage_9.44f19abf.png";